<template>
  <div class="list">
   <div class="zhuboItem" v-for="(item,index) in list" :key="index">
      <div class="headerBox">
         <img src="@/assets/img/xaiofei/data1/wq.png" class="headerBg" />
         <img src="@/assets/img/xaiofei/data1/nq.png" class="headerBg1" />
         <img src="@/assets/img/xaiofei/data1/gx.png" class="headerGuang" />
         <img :src="item.header" class="headerImg" />
      </div>
      <div class="right_font">
         <span>{{item.name}}</span>
         <span>粉丝量：{{item.fensi}}万</span>
      </div>
   </div>
  </div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props:["list"],
  setup(props) {
  
    onMounted(() => {
     
      
    });
    return {
      
    };
  },
};

</script>
<style lang="less" scoped>
   .list{
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .zhuboItem{
         width: 50%;
         display: flex;
         .headerBox{
            width:98px ;
            height: 98px;
            position: relative;
            .headerBg{
               position: absolute;
               top:0;
               left: 0;
               width: 100%;
               height: 100%;
               // animation: rightCircle 2s  linear infinite;
            }
            .headerBg1{
               position: absolute;
               top:9px;
               left:9px;
               width: 80px;
               height: 80px;
            }
            .headerGuang{
               position: absolute;
               bottom:-9px;
               left:5px;
               width: 97px;
               height: 17px;
               animation: guang 1s  linear infinite
            }
            .headerImg{
               width: 72px;
               height: 72px;
               position: absolute;
               top:13px;
               left: 13px;
               border-radius: 50%;
            }
         }
         .right_font{
            display: flex;
            flex-direction: column;
            font-size: 30px;
            justify-content: center; 
            align-items: flex-start; 
            margin-left: 20px; 
            span{
               display: block;
            }
         }
      }
   }
   @keyframes rightCircle { 
  0% {
          transform: rotate(0deg);
      }

  100% {
      transform: rotate(360deg);
  }
}
   @keyframes guang { 
  0% {
          transform: scale(.8);
   }
   50% {
      transform: scale(1);
      opacity: .5;
   }

  100% {
      transform:scale(.8);
  }
}
</style>
